import { makeStyles } from '@material-ui/core/styles';

// Cor de marca fixa — igual à SpikeSignInPage, não deriva de theme.palette
// (onde primary.main inverte para branco no dark) para manter o CTA
// consistente nos dois temas.
const BRAND_INDIGO = '#000050';

export const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: '12px',
    padding: theme.spacing(4, 4, 3),
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    boxShadow:
      theme.palette.type === 'dark'
        ? '0 4px 28px rgba(0, 0, 0, 0.55)'
        : '0 4px 24px rgba(17, 24, 39, 0.12)',
  },
  logo: {
    width: '40px',
    height: '40px',
    objectFit: 'contain',
    display: 'block',
    margin: '0 auto 16px',
  },
  title: {
    fontSize: '18px',
    fontWeight: 700,
    letterSpacing: '-0.2px',
    textAlign: 'center',
    margin: '0 0 10px',
    color: theme.palette.text.primary,
  },
  message: {
    fontSize: '13.5px',
    lineHeight: 1.6,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    margin: '0 0 24px',
  },
  primaryButton: {
    width: '100%',
    background: BRAND_INDIGO,
    color: '#ffffff',
    borderRadius: '8px',
    fontSize: '14.5px',
    fontWeight: 600,
    textTransform: 'none',
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1),
    '&:hover': {
      background: BRAND_INDIGO,
      opacity: 0.85,
    },
  },
  secondaryButton: {
    width: '100%',
    color: theme.palette.text.secondary,
    fontSize: '12.5px',
    textTransform: 'none',
  },
}));
